// extracted by mini-css-extract-plugin
export default {"shared":"'../../shared.module.css'","md":"768px","appContainer":"Layout_appContainer__oEA3k","footerWrapper":"Layout_footerWrapper__S8chN"};